import React from 'react';
import { AutoBind } from './lib/prevalent';
import { WebApi } from './lib/webapi';
import { ShowError, ShowInfo } from './special/error-view';
import { UsdtToText } from './special/convert';
import './css/style.css';
import show_password_icon from './img/show_password_icon.svg';
import hide_password_icon from './img/hide_password_icon.svg';
//import password_mask from './img/password_mask.svg';
import button_submit_arrow from './img/button_submit_arrow.svg';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './css/dialog.css';

export default class Page extends React.Component {
    constructor(props) {
        super(props);
        AutoBind(this);
        this.state = {
            showTypeList: false, ExchangeType: 0,
            fridnEmail: '', fridnPassword: '',
            fridnUSDTWallet: '', fridnFudAmount: '',
            fridnTerms: false,
            passwordShow: false,
            errEmail: false, errPasswd: false, errWallet: false, errAmount: false, errTerms: false,
            displayDialog1: false, price: {}
        };
    }

    onClickDiscard() {
        this.setState({
            fridnEmail: '', fridnPassword: '',
            fridnUSDTWallet: '', fridnFudAmount: '',
            fridnTerms: false,
            passwordShow: false,
            errEmail: false, errPasswd: false, errWallet: false, errAmount: false, errTerms: false
        });
    }

    onClickCurrentType() {
        this.setState(prevState => ({ showTypeList: !prevState.showTypeList }));
    }
    onClickTypeList() {
        this.setState(prevState => ({ showTypeList: !prevState.showTypeList, ExchangeType: 1 - prevState.ExchangeType }));
    }
    onChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
        const errState = { errEmail: false, errPasswd: false, errWallet: false, errAmount: false, errTerms: false }
        this.setState(errState);
    }

    onClickExchange() {
        const state = this.state;
        const errState = { errEmail: false, errPasswd: false, errWallet: false, errAmount: false, errTerms: false }
        let err = false;
        if (!state.fridnEmail) {
            errState.errEmail = true;
            err = true;
        }
        if (!state.fridnPassword) {
            errState.errPasswd = true;
            err = true;
        }
        if (!state.fridnUSDTWallet) {
            errState.errWallet = true;
            err = true;
        }
        if (state.ExchangeType === 1 && !state.fridnFudAmount) {
            errState.errAmount = true;
            err = true;
        }
        if (!state.fridnTerms) {
            errState.errTerms = true;
            err = true;
        }
        this.setState(errState);
        if (err) {
            return;
        }
        const aitxt = this.props.aitxt;
        let post = {
            fridnEmail: state.fridnEmail,
            fridnPassword: state.fridnPassword,
            fridnUSDTWallet: state.fridnUSDTWallet,
            fridnFudAmount: state.fridnFudAmount
        };
        if (state.ExchangeType === 0) {
            ShowInfo('info', 'info', aitxt[42]);
            WebApi('/usdt_exchange/api/exchangeUsdtToFaUnit', post,
                (data) => {
                    //console.log('data', data);
                    let msg = aitxt[39];
                    if (data.code === 2) {
                        msg = aitxt[40]
                    }
                    ShowInfo('success', 'Success', msg);
                    this.props.ShowPage(2);
                }, ShowError);
        } else if (state.ExchangeType === 1) {
            WebApi('/usdt_exchange/api/getExchangePrice', post,
                (data) => {
                    //console.log('data', data);
                    this.setState({ displayDialog1: true, price: data });
                }, ShowError);
        }
    }

    onContinue() {
        this.setState({ displayDialog1: false });
        const aitxt = this.props.aitxt;
        ShowInfo('info', 'info', aitxt[43]);
        const state = this.state;
        let post = {
            fridnEmail: state.fridnEmail,
            fridnPassword: state.fridnPassword,
            fridnUSDTWallet: state.fridnUSDTWallet,
            fridnFudAmount: state.fridnFudAmount
        };
        WebApi('/usdt_exchange/api/exchangeFaUnitToUsdt', post,
            (data) => {
                console.log('data', data);
                const msg = 'transfer FA.Unit to USDT successfully started';
                ShowInfo('success', 'Success', msg);
                this.props.ShowPage(3);
            }, ShowError);
    }

    onClickShowHidePassword() {
        this.setState(prevState => ({ passwordShow: !prevState.passwordShow }));
        let timer = setTimeout(() => {
            this.setState({ passwordShow: false });
            clearTimeout(timer);
        }, 12000)
    }

    onHide() {
        this.setState({ displayDialog1: false });
    }

    render() {
        const state = this.state;
        const { price } = state;
        const aitxt = this.props.aitxt;
        const ExchangeTypeText = [
            aitxt[37],
            aitxt[38]
        ];
        const footer = (
            <div>
                <Button label={aitxt[44]} icon="pi pi-times" className="p-button-secondary" onClick={this.onHide} />
                <Button label={aitxt[45]} icon="pi pi-check" onClick={this.onContinue} />
            </div>
        );
        return (
            <div className="s2_group">

                <Dialog header={aitxt[41]} visible={this.state.displayDialog1} footer={footer} onHide={this.onHide}>
                    <p>{aitxt[46]}</p>
                    <br />
                    <p>
                        {aitxt[48] + ' ~ ' + UsdtToText(price.EthFeeUsdt) + ' $'}<br />
                        {aitxt[49] + ' ~ ' + UsdtToText(price.Usdt) + ' USDT'}
                    </p>
                    <br />
                    <p className="price">
                        {aitxt[47]}
                    </p>
                </Dialog>

                <p className="s2_group_title">
                    <span>{aitxt[3]}</span>
                </p>
                <div className="wrapper">
                    <div className="wrap wrap-1">
                        <div className="field">
                            <p className="field_title">{aitxt[4]} <span>*</span></p>
                            <input type="email" className={state.errEmail ? 'field_input fielderror' : 'field_input'} placeholder="E-mail"
                                value={state.fridnEmail} name="fridnEmail" onChange={this.onChange} />
                        </div>
                    </div>
                    <div className="wrap wrap-1">
                        <p className="field_title">{aitxt[5]} <span>*</span></p>
                        <div className="password_wrap">
                            <input type={state.passwordShow ? 'text' : 'password'} className={state.errPasswd ? 'field_input fielderror' : 'field_input'}
                                value={state.fridnPassword} name="fridnPassword" onChange={this.onChange} />
                            <img src={show_password_icon} className={state.passwordShow ? 'password_icon' : 'password_icon active'} alt="" onClick={this.onClickShowHidePassword} />
                            <img src={hide_password_icon} className={state.passwordShow ? 'password_icon active' : 'password_icon'} alt="" onClick={this.onClickShowHidePassword} />
                            {/*<img src={password_mask} className="password_mask" alt="" />*/}
                        </div>
                    </div>
                    <div className="wrap wrap-1">
                        <p className="field_title">{aitxt[6]} <span>*</span></p>
                        <div className="field_input current_wallet" onClick={this.onClickCurrentType}>{ExchangeTypeText[state.ExchangeType]}</div>
                        <ul className={state.showTypeList ? 'wallet_list active' : 'wallet_list'} onClick={this.onClickTypeList}>
                            <li className="wallet_list_item">{ExchangeTypeText[1 - state.ExchangeType]}</li>
                        </ul>
                    </div>
                    <div className="type_group">
                        <div className="wrap wrap-1">
                            <div className="field">
                                <p className="field_title">{aitxt[7]} <span>*</span> <span className="field_title_red">{aitxt[8]}</span></p>
                                <input type="text" className={state.errWallet ? 'field_input fielderror' : 'field_input'} placeholder={aitxt[9]}
                                    value={state.fridnUSDTWallet} name="fridnUSDTWallet" onChange={this.onChange} />
                            </div>
                        </div>
                        {/*state.ExchangeType === 0 &&
                            <div className="wrap wrap-1">
                                <div className="field">
                                    <p className="field_title light">Fridn USDT wallet for exchange</p>
                                    <div className="copy_input_wrap">
                                        <input type="text" className="field_input" readOnly value="0xd6cbdea946605742d148b9d95a51f4d14c926ef1" />
                                        <p className="copy_message">Copied</p>
                                    </div>
                                </div>
                            </div>*/
                        }
                        {state.ExchangeType === 1 &&
                            <div className="wrap wrap-1">
                                <div className="field">
                                    <p className="field_title light">{aitxt[10]} <span>*</span></p>
                                    <input type="text" className={state.errAmount ? 'field_input fielderror' : 'field_input'} placeholder={aitxt[11]}
                                        value={state.fridnFudAmount} name="fridnFudAmount" onChange={this.onChange} />
                                </div>
                            </div>
                        }
                    </div>
                    <div className="info">
                        <div className="checkbox">
                            <input type="checkbox" className="check_info" name="fridnTerms" onChange={this.onChange} id="checkbox_1"
                                checked={state.fridnTerms} />
                            <label className={state.errTerms ? 'check_info_label checkerror' : 'check_info_label'} htmlFor="checkbox_1">{aitxt[12]}</label>
                        </div>
                    </div>
                    <div className="buttons_block">
                        <button type="reset" className="button button_reset" onClick={this.onClickDiscard}>{aitxt[13]}</button>
                        <button type="submit" className="button button_submit" onClick={this.onClickExchange}>
                            {state.ExchangeType === 0 ? aitxt[14] : aitxt[15]}
                            <span><img src={button_submit_arrow} alt="go" /></span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
